import React from "react";

/**
 * StatStrip — dark navy stats strip reused on Dashboard, ResultDetail,
 * MasterSuiteResults and UITestResultDetail.
 *
 * Props:
 *   stats   Array<{ label, value, color?, muted? }> — stat items
 *   passRate number (0-100) — if provided, renders a pass rate bar at the end
 *   passRateLabel string — label for pass rate bar (default "Pass rate")
 *   style   object — override outer div style
 */
function StatStrip({ stats = [], passRate, passRateLabel = "Pass rate", style = {} }) {
  const barColor = passRate === 100 ? "#86EFAC" : "#FCA5A5";

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      background: "#0B1F3A",
      borderRadius: 10,
      overflow: "hidden",
      ...style,
    }}>
      {stats.map(({ label, value, color, muted }, i) => (
        <div key={i} style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px 20px",
          borderRight: "0.5px solid rgba(255,255,255,0.15)",
          flexShrink: 0,
        }}>
          <span style={{
            fontSize: 22,
            fontWeight: 500,
            lineHeight: 1.2,
            color: muted ? "rgba(255,255,255,0.3)" : (color || "#fff"),
          }}>
            {value}
          </span>
          <span style={{
            fontSize: 11,
            color: "rgba(255,255,255,0.65)",
            marginTop: 3,
            whiteSpace: "nowrap",
          }}>
            {label}
          </span>
        </div>
      ))}

      {passRate !== undefined && (
        <div style={{ flex: 1, padding: "12px 20px", minWidth: 100 }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 11,
            color: "rgba(255,255,255,0.55)",
            marginBottom: 5,
          }}>
            <span>{passRateLabel}</span>
            <span style={{ fontWeight: 500, color: "#fff" }}>{passRate}%</span>
          </div>
          <div style={{ height: 6, background: "rgba(255,255,255,0.12)", borderRadius: 3, overflow: "hidden" }}>
            <div style={{
              height: "100%",
              width: `${passRate}%`,
              background: barColor,
              borderRadius: 3,
              transition: "width .4s",
            }} />
          </div>
        </div>
      )}
    </div>
  );
}

export default StatStrip;
